import './icon.scss';
import React, {MouseEventHandler} from 'react';
import classNames from 'clsx';
import {IconType} from './icons';

type InputProps = {
    icon: IconType;
    id?: string;
    className?: string;
    alt?: string;
    onClick?: MouseEventHandler<HTMLElement>;
    uncolored?: boolean;
    fading?: boolean;
};

export const SvgIcon = React.memo((props: InputProps) => {
    const Icon = props.icon;

    const className: string[] = ['icon'];

    if (props.onClick) {
        className.push('icon-button');
    }

    if (props.className) {
        className.push(props.className);
    }

    if (!props.uncolored) {
        className.push('icon-color');
    }

    if (props.fading) {
        className.push('icon-fading');
    }

    return (
        <span id={props.id} className={classNames(className)} onClick={props.onClick} title={props.alt}>
            <Icon />
        </span>
    );
});
